import { colors } from "lib/theme";
import { Global, css } from "@emotion/core";

const GlobalCss = (p) => (
  <Global
    styles={css`
      // Global height layout styles
      html,
      body {
        min-height: 100vh;
        min-height: -webkit-fill-available;
        // a child can't use a height percentage unless the parent has a specified height. Even if it's 1px
        height: 1px;
      }
      #__next {
        min-height: 100%;
        // a child can't use a height percentage unless the parent has a specified height. Even if it's 1px
        height: 1px;

        // Using safe-area and -webkit-fill-available on the same element causes
        // it to also shrink by the same amount, as if there was an equal margin
        ${p.bottomSafeArea && "padding-bottom: env(safe-area-inset-bottom, 0);"}
      }

      // Global decorative styles
      body {
        background-color: ${p.background};
      }
      ::selection {
        background: ${colors.navy[50]};
      }
      #__next {
        ${p.isApp && `user-select: none;`}
      }

      // Additional resets
      button {
        // sanitize.css makes button inherit typography styles, but doesn't correct font smoothing for webkit
        -webkit-font-smoothing: inherit;
        -moz-osx-font-smoothing: inherit;
      }
    `}
  />
);

GlobalCss.defaultProps = {
  background: colors.white,
  bottomSafeArea: true,
};

export { GlobalCss };
